import { apiGet } from './api';

export interface HomeRanking {
  nation: { victoryNation: number; endDateTime: string };
  nationOposto: number;
  countWar: number;
  memorial: RankPlayer[];
  portadores: RankPlayer[];
}

export interface RankPlayer {
  // characterIdx removido por seguranca (era ID interno em endpoint publico).
  characterName: string;
  classId: number;
  nation: number;
  guildName: string;
  warPoint?: number;
  combat?: number;
  pveAttack?: number;
  pveDefense?: number;
  kills?: number;
  level?: number;
}

export interface GuildRank {
  guildName: string;
  point: number;
  nation?: number;
  memberCount: number;
  powerTotal?: number;   // SUM(Combat) dos membros
  warPoints?: number;    // SUM(WarPoint) dos membros
  warKills?: number;     // SUM(KillCount) dos membros
}

/** GET /Ranking/home — dados do memorial + portadores (publico) */
export const getRankingHome = () => apiGet<HomeRanking>('/Ranking/home');

/** GET /Ranking/points — ranking de guerra (publico) */
export const getRankingPoints = (style: number = 0, nation: number = 0) =>
  apiGet<RankPlayer[]>('/Ranking/points', { style, nation });

/** GET /Ranking/PowerCombat — ranking de poder de combate (publico) */
export const getRankingPower = (style: number = 0, nation: number = 0) =>
  apiGet<RankPlayer[]>('/Ranking/PowerCombat', { style, nation });

/** GET /Ranking/guilds — ranking de guildas (publico) */
export const getRankingGuilds = (take: number = 50) =>
  apiGet<GuildRank[]>('/Ranking/guilds', { take });

/** Recorde de DPS por classe/modo — dashboard "Dano por Segundo" da home. */
export interface DpsRecord {
  classId: number;         // 1-9
  mode: number;            // 0 = PvE, 1 = PvP
  bestDps: number;
  bestSingleHit: number;
  holderName: string | null;
  achievedAt: string | null;
}

/** GET /Ranking/dpsRecords — 18 recordes (9 classes x PvE/PvP), publico. */
export const getDpsRecords = () => apiGet<DpsRecord[]>('/Ranking/dpsRecords');
